export default "__VITE_ASSET__BcIq9veM__"